import helper from "../helper";

let getPassOrderUrl = helper.getPassOrderUrlWithParameters
let getPassOrderAllowed = helper.allowedPassOrderUrl

export default {
    getPassOrderUrl,
    getByRecievedUrlData: (url, gets = null) => getPassOrderUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    REPRESENTATIVE: {
        ALLOWED: () => getPassOrderAllowed(
            "representative|orders|orders-list",
            "list"
        ),
        ALLOWED_REPLACEMENT: () => getPassOrderAllowed(
            "representative|roles|replacement-list",
            "list"
        ),
        ORDERS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "representative|orders|orders-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (through_number, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-detail",
                    "retrieve",
                    {id: through_number},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "representative|orders|orders-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (through_number, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-detail",
                    "partial_update",
                    {id: through_number},
                    gets
                ),
            DELETE:
                (through_number, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-detail",
                    "destroy",
                    {id: through_number},
                    gets
                ),
            FORM:
                (id, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-form",
                    "form",
                    {id: id},
                    gets
                ),
            COPY:
                (id, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-copy",
                    "copy",
                    {id: id},
                    gets
                ),
            WITHDRAW:
                (id, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-withdraw",
                    "withdraw",
                    {id: id},
                    gets
                ),
            ANNUL:
                (id, gets = null) => getPassOrderUrl(
                    "representative|orders|orders-annul",
                    "annul",
                    {id: id},
                    gets
                ),
            LIMITS:
                (gets = null) => getPassOrderUrl(
                "base|orders|get|my|limits",
                "get",
                null,
                gets
                ),
            USER_ORGANIZATION:
                (gets = null) => getPassOrderUrl(
                    "base|user|organization",
                    "get",
                    null,
                    gets
                ),
        },
        REPLACEMENTS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "representative|roles|replacement-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "representative|roles|replacement-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "representative|roles|replacement-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "representative|roles|replacement-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "representative|roles|replacement-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        }
    }
}
